import React from "react";
import { ButtonProps, DetailsButton } from "sprint-common-web";

import { CloudFileStatusDetailsAside } from "./CloudFileStatusDetailsAside";

export type CloudFileStatusDetailsButtonAsideProps = Pick<ButtonProps, "disabled"> & {
    itemId: string;
    onClose(): void;
    isOpen: boolean;
};

export const CloudFileStatusDetailsButtonAside: React.FC<CloudFileStatusDetailsButtonAsideProps> = (
    props: CloudFileStatusDetailsButtonAsideProps
) => {
    const { disabled, itemId, isOpen, onClose } = props;

    return (
        <>
            <DetailsButton id={itemId} disabled={disabled} testId="status-details-button" />
            <CloudFileStatusDetailsAside cloudFileId={itemId} isOpen={isOpen} onClose={onClose} />
        </>
    );
};
